module.exports = __webpack_public_path__ + "img/7H.c1114c8c.png";